import { render, staticRenderFns } from "./ygList.vue?vue&type=template&id=ffc8c0e6&scoped=true&"
import script from "./ygList.vue?vue&type=script&lang=js&"
export * from "./ygList.vue?vue&type=script&lang=js&"
import style0 from "./ygList.vue?vue&type=style&index=0&id=ffc8c0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc8c0e6",
  null
  
)

export default component.exports